import React from "react"
import { Header } from "./components/Header"
import { IframeChat } from "./components/IframeChat"
import { ThemeProvider } from "./components/ThemeProvider"

function App() {
  return (
    <ThemeProvider defaultTheme="dark">
      <main className="flex min-h-screen flex-col bg-[#1e1e1e]">
        <Header />
        <div className="container mx-auto px-4 py-6 flex-1 flex flex-col">
          <div className="flex-1">
            <IframeChat />
          </div>
        </div>
      </main>
    </ThemeProvider>
  )
}

export default App

